import Search from 'antd/lib/input/Search'
import React from 'react'
import { useTranslation } from 'react-i18next'

type MilestoneControlsType = {
  onSearch: (search: string) => void
}

export const MilestoneControls = ({ onSearch }: MilestoneControlsType) => {
  const { t } = useTranslation()

  return (
    <div className="d-flex justify-content-between">
      <div>
        <Search
          onChange={(event) => onSearch(event.target.value)}
          placeholder={t('workspace.searchMilestones')}
        />
      </div>
      {/*<div className={clsx(styles.filterSelectWrapper, 'ml-1')}>*/}
      {/*  <PureSelect*/}
      {/*    onChange={onFilter}*/}
      {/*    options={selectionStatuses}*/}
      {/*    placeholder={t('common.all')}*/}
      {/*    size="small"*/}
      {/*    value={defaultSelectionValue}*/}
      {/*  />*/}
      {/*</div>*/}
    </div>
  )
}
